function bankModulewithdrawEMoney(){

    let withdrawEMoneyService = [
        {
            name: "Withdraw E-Money",
            icon: "Withdraw E-Money",
            logoName: "Withdraw_E_Money",
            // flag: "voucherRequired",
            displayService: "bankWithdrawEMoney",
            items: [],
        },
    ]

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/withdray-emoney-dashboard",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const withdrawEMoney = () => {
        const withdrawEMoneyArr = [
            {
                path: "/index/bank-withdray-emoney",
                name: "Withdraw E-Money",
                icon: "Withdraw E-Money",
                logoName: "Withdraw_E_Money",
                flag: "",
            },
        ];

        return withdrawEMoneyArr;
    }

    let a = dashboard();
    let b = withdrawEMoney();

    withdrawEMoneyService[0].items = [...a, ...b];

    return withdrawEMoneyService;

}

export default bankModulewithdrawEMoney;